<template>
    <!-- ---------------------------------- 预约空气检查 ---------------------------------- -->
    <div class="detection">
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Header></Header>
        <!-- ---------------------------------- 海报图 ---------------------------------- -->
        <div class="banner">
            <p>拥抱清新的空气</p>
        </div>
        <!-- ---------------------------------- 表格 ---------------------------------- -->
        <div class="form">
            <!-- 标语 -->
            <div class="slogan">
                <p>
                    Renaud专业团队提供上门室内空气检测服务，<br />通过仪器检测您的家中是否存在会影响健康的室内空气污染物。
                </p>
            </div>
            <!-- 表格 -->
            <Form
                :noArr="[
                    'models',
                    'serviceAddress',
                    'adress',
                    'company',
                    'eamil',
                    'customer',
                    'nowClean',
                    'nowExtended',
                    'nowSpecial',
                    'nowDetectionOrigan',
                ]"
                :type="94"
            ></Form>
            <!-- 提示 -->
            <p class="form_tips">
                由于需求量大，因此我们每周只能安排有限的免费空气质量检测
            </p>
        </div>
        <!-- ---------------------------------- 测试范围、用家体验 ---------------------------------- -->
        <div class="service">
            <!-- 测试范围 -->
            <div class="test">
                <!-- 标题 -->
                <p class="service_title">检测范围</p>
                <!-- 横线 -->
                <div class="service_line"></div>
                <!-- 内容 -->
                <div>
                    <img src="../assets/images/icon/test1.png" alt="" />
                    <p class="copy">
                        我们的专家将指导您使用Renaud的4步净化过程，以确保您家中的室内空气质量符合世界卫生组织的清洁空气标准。
                    </p>
                </div>
                <div>
                    <img src="../assets/images/icon/test2.png" alt="" />
                    <p class="copy">
                        找出您家中是否存在PM2.5及室内有害空气污染物，预防呼吸问题、过敏反应、发热和哮喘。
                    </p>
                </div>
                <div>
                    <img src="../assets/images/icon/test3.png" alt="" />
                    <p class="copy">
                        根据世界卫生组织的数据，室内空气污染通常是室外污染水平的2至5倍。在某些情况下，室内空气污染指数甚至高出100倍。
                    </p>
                </div>
            </div>
            <!-- 用家体验 -->
            <div class="home">
                <!-- 标题 -->
                <p class="service_title">用家体验</p>
                <!-- 横线 -->
                <div class="service_line"></div>
                <!-- 双引号 -->
                <img
                    class="quotes_left"
                    src="../assets/images/icon/quotes-left.png"
                    alt=""
                />
                <img
                    class="quotes_right"
                    src="../assets/images/icon/quotes-right.png"
                    alt=""
                />
                <!-- Sophie Li -->
                <div class="message_one">
                    <p>
                        一项非常专业的服务。空气检测团队在检查我们<br />公寓的PM2.5水平方面做得非常出色。我们甚至<br />在检测之前都不知道该水平有多高和不健康。
                    </p>
                    <span>Sophie Li</span>
                </div>
                <!-- Jogn Choi -->
                <div class="message_two">
                    <p>
                        在进行空气质量检测之前，我们不知道<br />我们的空气有多糟糕。难怪我们一直都<br />过敏。我和我的家人感谢Renaud的空<br />气净化服务。
                    </p>
                    <span>Jogn Choi</span>
                </div>
                <!-- Harj Patel -->
                <div class="message_three">
                    <p>
                        我不得不说，安排空气检测是我为家人所<br />做的最好的事情。现在，我们可以在家中<br />轻松呼吸。我的孩子不再需要吸入器。
                    </p>
                    <span>Harj Patel</span>
                </div>
            </div>
        </div>
        <!-- ---------------------------------- 视频 ---------------------------------- -->
        <div class="video">
            <!-- 标题 -->
            <p>只需简单一步，即可在家中享受清新空气</p>
            <!-- 横线 -->
            <div class="video_line"></div>
            <!-- 视频 -->
            <div class="video_box">
                <!-- <video controls="controls" autobuffer width="50%" height="100%" style="object-fit: fill;margin:0 auto;display:block;" src="https://v.qq.com/txp/iframe/player.html?vid=w0793y5ftlr"></video> -->
                <video
                    width="100%"
                    poster="http://118.89.87.102:8080/jeecg-boot/sys/common/static/pic/FREEIAQVIDPHOTO.png"
                    controls
                    height="100%"
                    style="object-fit: fill; margin: 0 auto; display: block"
                    frameborder="0"
                   src="http://118.89.87.102/FreeIndoorAirQualityTestingfromRenaudAir_1.mp4"
                    allowFullScreen="true"
                ></video>
            </div>
        </div>
        <!-- ---------------------------------- 顶部导航栏 ---------------------------------- -->
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Form from '@/components/Form';
export default {
    components: {
        Header,
        Footer,
        Form,
    },
    data() {
        return {
            video: 'w3257t6l06b.html',
            type: 94,
            models: {},
        };
    },
};
</script>

<style lang="less" scoped>
// ---------------------------- 海报图 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .banner {
        height: 600px;
        background: url('../assets/images/detection-banner.png') no-repeat;
        background-size: cover;
        p {
            font-size: 84px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .banner {
        height: 550px;
        background: url('../assets/images/detection-banner.png') no-repeat;
        background-size: 100% 100%;
        p {
            font-size: 64px;
        }
    }
}
.banner {
    width: 100%;
    background-position: center;
    position: relative;
    p {
        color: #5a357d;
        letter-spacing: 10px;
        position: absolute;
        top: 40%;
        right: 10%;
        margin: 0;
    }
}

// ---------------------------- 表格 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 标语
    .slogan {
        height: 535px;
        p {
            font-size: 56px;
            width: 68%;
            margin: 0 auto;
            padding-top: 6.5%;
        }
    }
    // 提示
    .form_tips {
        font-size: 50px;
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    // 标语
    .slogan {
        height: 205px;
        p {
            font-size: 36px;
            font-weight: lighter;
            margin: 0;
            padding-top: 2%;
        }
    }
    // 提示
    .form_tips {
        font-size: 22px;
    }
}
.form {
    width: 100%;
    background-color: #eff6e8;
    // 标语
    .slogan {
        width: 100%;

        background: url('../assets/images/detection-bg.png') no-repeat;
        background-size: 100% 100%;
        background-position: center;
        margin-bottom: 50px;
        p {
            color: #ffffff;
            letter-spacing: 2px;
            text-align: center;
            line-height: 1.5;
        }
    }
    // 提示
    .form_tips {
        color: #727171;
        text-align: center;
        margin: 0 auto;
        letter-spacing: 2px;
        padding: 0 0 74px 0;
    }
}

// ---------------------------- 测试范围、用家体验 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    // 标题
    .service_title {
        font-size: 60px;
    }
        // 横线
    .service_line {
        width: 25% !important;
        margin: 0 auto;
        border-bottom: 3px solid #5a357d;
        margin-top: 20px;
        margin-bottom: 80px;
    }
    // 测试范围
    .test {
        div {
            display: flex;
            align-items: center;
            justify-content: center;
            // 图标
            img {
                width: 145px;
                height: 145px;
                margin-top: -55px;
            }
            // 文案
            .copy {
                width: 50%;
                font-size: 48px;
                text-align: left;
                line-height: 1.4;
                margin-left: 50px;
                padding: 15px 0 15px 0;
            }
        }
    }
    // 用家体验
    .home {
        height: 1600px;
        // 双引号
        .quotes_left {
            width: 172px;
            position: absolute;
            top: 13%;
            left: 19%;
        }
        .quotes_right {
            width: 172px;
            position: absolute;
            bottom: 5%;
            right: 8%;
        }
        // Sophie Li
        .message_one {
            width: 55%;
            height: 426px;
            position: absolute;
            top: 15%;
            right: 8%;
            p {
                font-size: 44px;
                margin-left: 6.5%;
                padding-top: 5.8%;
            }
            span {
                font-size: 53px;
                margin: 165px 140px 0 0;
            }
        }
        // Jogn Choi
        .message_two {
            width: 55%;
            height: 436px;
            position: absolute;
            top: 40%;
            left: 7%;
            p {
                font-size: 44px;
                margin: 4% 0 0 15%;
            }
            span {
                font-size: 53px;
                margin: 140px 0 0 100px;
            }
        }
        // Harj Patel
        .message_three {
            width: 53%;
            height: 404px;
            position: absolute;
            bottom: 14%;
            right: 8%;
            p {
                font-size: 44px;
            }
            span {
                font-size: 53px;
            }
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .service {
        display: flex;
        // 标题
        .service_title {
            font-size: 50px;
        }
        // 测试范围
        .test {
            width: 50%;
            // 图标
            img {
                width: 100px;
                display: block;
                margin: 0 auto;
            }
            // 文案
            .copy {
                width: 65%;
                margin: 0 auto;
                font-size: 30px;
                text-align: justify;
                line-height: 1.5;
                padding: 23px 0 33px 0;
            }
        }
        // 用家体验
        .home {
            width: 50%;
            // 双引号
            .quotes_left {
                width: 112px;
                position: absolute;
                top: 13%;
                left: 9%;
            }
            .quotes_right {
                width: 112px;
                position: absolute;
                bottom: 8%;
                right: 8%;
            }
            // Sophie Li
            .message_one {
                width: 669px;
                height: 216px;
                position: absolute;
                top: 22%;
                right: 12%;
                p {
                    font-size: 24px;
                    margin-left: 12%;
                    padding-top: 25px;
                }
                span {
                    font-size: 33px;
                    margin: 65px 10px 0 0;
                }
            }
            // Jogn Choi
            .message_two {
                width: 517px;
                height: 276px;
                position: absolute;
                top: 41%;
                left: 9%;
                p {
                    font-size: 24px;
                    margin: 6% 0 0 10.5%;
                }
                span {
                    font-size: 33px;
                    margin: 100px 0 0 20px;
                }
            }
            // Harj Patel
            .message_three {
                width: 563px;
                height: 234px;
                position: absolute;
                bottom: 18%;
                right: 12%;
                p {
                    font-size: 24px;
                }
                span {
                    font-size: 33px;
                }
            }
        }
    }
}
.service {
    width: 100%;
    // 标题
    .service_title {
        color: #5a357d;
        letter-spacing: 10px;
        text-align: center;
        margin: 0;
    }
    // 横线
    .service_line {
        width: 40%;
        margin: 0 auto;
        border-bottom: 3px solid #5a357d;
        margin-top: 20px;
        margin-bottom: 80px;
    }
    // 测试范围
    .test {
        background-color: #e2e0eb;
        padding: 83px 0 90px 0;
        // 文案
        .copy {
            color: #5a357d;
        }
    }
    // 用家体验
    .home {
        background-color: #c8c2dc;
        padding: 83px 0 0 0;
        position: relative;
        // Sophie Li
        .message_one {
            background: url('../assets/images/icon/message1.png') no-repeat;
            background-size: 100% 100%;
            background-position: center;
            p {
                color: #0d1d41;
                line-height: 1.5;
            }
            span {
                color: #5a357d;
                font-weight: bold;
                float: right;
            }
        }
        // Jogn Choi
        .message_two {
            background: url('../assets/images/icon/message2.png') no-repeat;
            background-size: 100% 100%;
            background-position: center;
            p {
                color: #0d1d41;
                line-height: 1.6;
            }
            span {
                color: #5a357d;
                font-weight: bold;
                float: left;
            }
        }
        // Harj Patel
        .message_three {
            background: url('../assets/images/icon/message3.png') no-repeat;
            background-size: 100% 100%;
            background-position: center;
            p {
                color: #0d1d41;
                line-height: 1.6;
                padding: 15.5% 0 0 12%;
            }
            span {
                color: #5a357d;
                font-weight: bold;
                float: right;
                margin: -52% 0 0 0;
            }
        }
    }
}

// ---------------------------- 视频 ---------------------------------
// ------------- mobile端样式 -------------
@media only screen and (max-width: 960px) {
    // 屏幕小于960px
    .video {
        // 标题
        p {
            font-size: 66px;
        }
        // 横线
        .video_line {
            width: 78%;
        }
        // 视频
        .video_box {
            width: 78%;
            // height: 681px;
        }
    }
}
// ------------- pc端样式 -------------
@media only screen and (min-width: 960px) {
    // 屏幕大于960px
    .video {
        // 标题
        p {
            font-size: 46px;
        }
        // 横线
        .video_line {
            width: 58%;
        }
        // 视频
        .video_box {
            width: 900px;
            height: 481px;
        }
    }
}
.video {
    width: 100%;
    background-color: #eff6e8;
    padding: 90px 0 97px 0;
    // 标题
    p {
        color: #5a357d;
        letter-spacing: 8px;
        text-align: center;
        margin: 0;
    }
    // 横线
    .video_line {
        margin: 0 auto;
        border-bottom: 3px solid #5a357d;
        padding: 30px 0 0 0;
        margin-bottom: 50px;
    }
    // 视频
    .video_box {
        margin: 0 auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/airtest.vue